import { Text } from 'foundations-components/components/Text';
import MdxHeader from './MdxHeader';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledH5 = props => /*#__PURE__*/_jsx(Text, Object.assign({}, props, {
  as: "h5"
}));
function MdxH5(props) {
  const {
    children
  } = props;
  return /*#__PURE__*/_jsx(MdxHeader, {
    Component: StyledH5,
    marginBlockStart: "1100",
    marginBlockEnd: "400",
    children: children
  });
}
export default MdxH5;